import { Box, Stack, SxProps, Typography, useTheme } from "@mui/material";
import { SenecDigitalIcon } from "src/components/error/error-illustrations/SenecDigitalIcon";
import { SenecBaseTheme, SenecButton } from "src/newsenec-ui-components";
import { findTranslations } from "src/components/error/senec-error-page/i18n";

export interface SenecErrorPageProps {
    /** title of the page */
    title?: string;
    /** details describing the error */
    description?: string;
    /** button text for reloading the page */
    reloadButtonMessage?: string;
    errorCode?: string;
    errorTraceId?: string;
    /** error page container sx props */
    sx?: SxProps;
}

export const SenecErrorPage = ({ title, description, reloadButtonMessage, errorCode, errorTraceId, sx }: SenecErrorPageProps) => {
    const theme: SenecBaseTheme = useTheme();
    const fallbackTranslations = findTranslations(navigator.language);

    return (
        <Stack alignItems="center" justifyContent="center" minHeight="60vh" mx="2rem" my="4rem" sx={sx}>
            <Stack alignItems="start" spacing={1}>
                <Box display="flex" alignItems="center" height="100px">
                    <SenecDigitalIcon />
                </Box>

                <Typography variant="h2">{title ?? fallbackTranslations.title}</Typography>
                <Typography>{description ?? fallbackTranslations.description}</Typography>
                {errorCode && errorTraceId && (
                    <Typography
                        sx={{ whiteSpace: "pre-line", color: theme.palette.neutralGray70.main }}
                    >{`${errorCode}\n${errorTraceId}`}</Typography>
                )}
                <SenecButton size="small" style={{ marginTop: "2rem" }} onClick={() => window.location.reload()}>
                    {reloadButtonMessage ?? fallbackTranslations.reloadPage}
                </SenecButton>
            </Stack>
        </Stack>
    );
};
